// extracted by mini-css-extract-plugin
export default {"productGrid":"X0-z","centerLink":"Y0-z","productSection":"Z0-z","item":"_0-z","ctaButton":"a1-z"};